<template>
  <div id="homePage">
    <!-- 头部 -->
    <div class="h-header" style="height: 60px">
      <v-header :menuList="elMenu.data" @changeMenu="changeMenu_header"></v-header>
    </div>
    <div id="pageContent">
      <!-- pc 端显示 -->
      <elMenus @select="handleSelect" class="pc" v-model="elMenu"></elMenus>

      <router-view class="content" />
      <!-- 移动端显示 -->
      <FloatingButton :width="50" :height="50" :Cleft="0.1">
        <div slot="text" class="Android flexNormal">
          <el-popover placement="bottom" trigger="click" :append-to-body="false">
            <elMenus @select="handleSelect" :isCollapse="true" v-model="elMenu"></elMenus>
            <div class="reference flexNormal" slot="reference">
              <img src="../assets/img/fi_file-text.png" alt="" />
              菜单
            </div>
          </el-popover>
        </div>
      </FloatingButton>
    </div>
  </div>
</template>

<script>
import vHeader from '../components/homePage/header.vue';
import elMenus from '../components/homePage/elMenus';
export default {
  name: 'homePage',
  components: { vHeader, elMenus },
  data() {
    return {
      elMenu: {
        isCollapse: false, // 是否折叠
        defaultActive: '0', // 当前激活菜单的 index
        data: [],
      },
      menuList_admin: [
        {
          id: '1',
          name: '评审管理',
          icon: 'el-icon-time',
          url: '/reviewManagement',
          ifMsg: true,
          num_msg: 0,
        },
        {
          id: '2',
          name: '行业分类管理',
          icon: 'el-icon-message',
          url: '/tradeManage',
          num_msg: 0,
        },
        {
          id: '3',
          name: '题库管理',
          icon: 'el-icon-document',
          url: '/questionBank',
          num_msg: 0,
        },
        {
          id: '4',
          name: '评审细则管理',
          icon: 'el-icon-document',
          url: '/testPaper',
          num_msg: 90,
        },
        // {
        //   id: '5',
        //   name: '数据分析',
        //   icon: 'el-icon-data-line',
        //   url: '/tradeManage/dataAnalysis',
        // },
      ],
      menuList_user: [
        {
          id: '1',
          name: '企业整体评价',
          icon: 'el-icon-monitor',
          url: '/accountPages/detail_org',
          num_msg: 0,
        },
        {
          id: '2',
          name: '评审管理',
          icon: 'el-icon-document',
          url: '/selfAssess',
          num_msg: 90,
        },
        {
          id: '3',
          name: '创建评审',
          icon: 'el-icon-time',
          url: '/reviewManagement',
          ifMsg: true,
          num_msg: 0,
        },
        {
          id: '4',
          name: '内容管理',
          icon: 'el-icon-document',
          url: '/questionBank',
          num_msg: 0,
        },
        {
          id: '5',
          name: '模块管理',
          icon: 'el-icon-document',
          url: '/testPaper',
          num_msg: 90,
        },
        {
          id: '6',
          name: '用户组织管理',
          icon: 'el-icon-user',
          url: '/accountPages/orgManage',
        },
        // {
        //   id: '4',
        //   name: '数据分析',
        //   icon: 'el-icon-data-line',
        //   url: '/accountPages/dataAnalysis',
        // },
      ],
      menuList_expert: [
        {
          id: '1',
          name: '评审管理',
          icon: 'el-icon-document',
          url: '/expertAssess',
          num_msg: 90,
        },
        // {
        //   id: '3',
        //   name: '数据分析',
        //   icon: 'el-icon-document',
        //   url: '/',
        //   num_msg: 90,
        // },
      ],
    };
  },
  watch: {
    $route: 'getMessageData',
  },
  created() {
    this.elMenu.defaultActive = sessionStorage.getItem(`${this.alias}elMenu`) ?? '1';
  },
  mounted() {
    this.changeMenu_header();
    this.getMessageData();
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    changeMenu_header(val) {
      let index = Number(this.elMenu.defaultActive) - 1;
      // 管理员
      switch (this.common.isLogin()) {
        case -1: // 管理员
          this.elMenu.data = JSON.parse(JSON.stringify(this.menuList_admin));
          break;
        case -2: // 专家
          this.elMenu.data = JSON.parse(JSON.stringify(this.menuList_expert));
          break;
        default:
          // 用户
          this.elMenu.data = JSON.parse(JSON.stringify(this.menuList_user));
          break;
      }
      if (this.$route.path == '/homePage') {
        this.$router.push(this.elMenu.data[index].url);
      }
    },
    handleSelect(menu, ifFilter) {
      this.elMenu.defaultActive = menu.id;
      sessionStorage.setItem(`${this.alias}elMenu`, menu.id);
      this.$router.push({ path: menu.url });
    },
    // 递归循环查找参数
    findMenuItemById(id, menuItems) {
      for (let i = 0; i < menuItems.length; i++) {
        const menuItem = menuItems[i];
        if (menuItem.id === id) {
          return menuItem;
        }
        if (menuItem.child && menuItem.child.length > 0) {
          const foundItem = this.findMenuItemById(id, menuItem.child);
          if (foundItem) {
            return foundItem;
          }
        }
      }
      return null;
    },
    // 递归循环查找参数
    findMenuItemByURl(url, menuItems) {
      for (let i = 0; i < menuItems.length; i++) {
        const menuItem = menuItems[i];
        if (menuItem.url === url) {
          return menuItem;
        }
        if (menuItem.child && menuItem.child.length > 0) {
          const foundItem = this.findMenuItemByURl(url, menuItem.child);
          if (foundItem) {
            return foundItem;
          }
        }
      }
      return null;
    },
    //获取整体消息小红点
    getMessageData() {
      this.$axios
        .post(`${process.env.BASE_URL}api/reviewRecord/redCount`)
        .then((res) => {
          if (res.data.code == 200) {
            this.elMenu.data.forEach((menu) => {
              if (menu.ifMsg) {
                this.pushMsgNum(menu, res.data);
              }
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
            });
          }
        })
        .catch(() => {});
    },
    pushMsgNum(item, resData) {
      switch (item.url) {
        case '/reviewManagement':
          item.num_msg = resData.data;
          break;
      }
    },
  },
};
</script>
<!-- pc 端代码 -->
<style lang="less" scoped>
.content {
  overflow: auto;
  padding-top: 0;
  padding: 20px;
  height: calc(100vh - 60px);
  box-sizing: border-box;
  position: relative;
  flex: 1;
}
</style>
<!-- 移动端代码 -->
<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  #pageContent {
    display: flex;
    height: calc(100vh - 60px);
  }

  .Android {
    display: none;
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #pageContent {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 60px);
  }
  .content {
    padding: 10px;
  }

  .pc {
    display: none;
  }

  .Android {
    width: 50px;
    height: 50px;
    background-color: @theme_color;
    display: flex;
    box-sizing: border-box;
    border-radius: 6px;

    // 弹窗的样式
    /deep/.el-popover {
      background: transparent;
      padding: 0;
      border: none;
      box-shadow: none;
      max-height: 80vh;
      overflow: auto;

      .popper__arrow {
        display: none;
      }
    }

    // 弹窗按钮的样式
    .reference {
      // font-size: 18px;
      // width: 28px;
      // height: 28px;
      // margin: 0 10px;

      cursor: pointer;
      display: flex;
      flex-direction: column;
      color: #ebeced;
      font-size: 12px;

      // background: rgba(255, 255, 255, 0.12);
    }

    // 移动端 导航栏右边内容
    .right {
      background-color: #fff;
      height: 100%;
      justify-content: flex-start;
      padding: 0 15px;
      flex: 1;

      i {
        font-size: 24px;
      }
    }
  }
}
</style>
